import { MetricField } from "../../../gql-generated/types";
import { countryFullNameMap } from "../label-maps";

export const osDimensionLabelMap: Record<string, string> = {
    OS_ANDROID: "Android",
    OS_IOS: "iOS",
    OS_UNKNOWN: "Unknown",
    OS_CHROMIUM_OS: "Chromium",
    OS_WINDOWS: "Windows",
    OS_OSX: "Mac OS",
    OS_OTHER: "Other",
} as const;

export const genderDimensionsLabelMap: Record<string, string> = {
    FEMALE: "Female",
    MALE: "Male",
    UNKNOWN: "Unknown Gender",
};

export const ageDimensionsLabelMap: Record<string, string> = {
    AGE_13_17: "Age 13-17",
    AGE_18_20: "Age 18-20",
    AGE_21_24: "Age 21-24",
    AGE_25_34: "Age 25-34",
    AGE_35_UP: "Age 35+",
    AGE_UNKNOWN: "Age Unknown",
};

export const totalDimensionsLabelMap: Record<string, string> = {
    // use pseudo dimension to follow Dimension Funnel Map format
    TOTAL: "All",
};

export enum Dimension {
    TOTAL = "TOTAL",
    AGE = "AGE",
    GENDER = "GENDER",
    OS = "OS",
    COUNTRY = "COUNTRY",
    ALL_USERS = "ALL_USERS",
}

export const dimensionLabelsMap: Record<Dimension, Record<string, string>> = {
    [Dimension.TOTAL]: totalDimensionsLabelMap,
    [Dimension.OS]: osDimensionLabelMap,
    [Dimension.GENDER]: genderDimensionsLabelMap,
    [Dimension.AGE]: ageDimensionsLabelMap,
    [Dimension.COUNTRY]: countryFullNameMap,
    [Dimension.ALL_USERS]: {},
};

export const displayDimensionsMap: Record<Dimension, string> = {
    [Dimension.COUNTRY]: "Country",
    [Dimension.AGE]: "Age",
    [Dimension.GENDER]: "Gender",
    [Dimension.OS]: "Device Operating System",
    [Dimension.TOTAL]: "",
    [Dimension.ALL_USERS]: "",
};

export const metricsLabels: Partial<Record<MetricField, string>> = {
    [MetricField.LensViews]: "Views",
    [MetricField.LensPlays]: "Plays",
    [MetricField.LensLongPlays]: "Long Plays",
    [MetricField.LensShares]: "Shares",
    [MetricField.Favorites]: "Favorites",
};
